<template>
  <el-menu
    :default-active="myInfoMenuActiveIndex"
    class="el-menu-small"
    mode="horizontal"
  >
    <el-menu-item index="1"
      ><router-link :to="{ path: '/myInfo' }"
        >基本信息</router-link
      ></el-menu-item
    >
    <el-menu-item index="2"
      ><router-link :to="{ path: '/safeSettings' }"
        >安全设置</router-link
      ></el-menu-item
    >
  </el-menu>
</template>

<script>
export default {
  name: 'MyInfoMenu',
  props: {
    myInfoMenuActiveIndex: String,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped></style>
